import React from 'react';
import { useEffect, useState, useRef } from "react"
import * as Font from 'expo-font';
import type { CompanyEmbedProps, CompanyProps, EmbedPropertyProps, EmbedProps, ItemOrderProps, MyPlayerProps, OrderProps, PlayerBalanceProps } from "../../src/types"
import { Button, Text, View } from "../../src/Components/Themed"
import { APIOverrides, BEClarity } from 'be-components';
import type { AuthStateProps } from '../../src/ApiOverrides/types';
import { ProfileApi } from '../../src/ProfileManager/api';
import { Image, Linking, useWindowDimensions } from 'react-native';
import AuthenticatorHolder from './components/AuthenticatorHolder';
import ProfileHolder from './components/ProfileHolder';
import MarketEmbed from '../market2';
import { CompanyProfileApi } from '../../src/SocialComponents/CompanyProfile/api';
import { CircularFadeOut, Icons } from '../../src/Components';
import { useColors } from '../../src/constants/useColors';
import WalletHolder from './components/WalletHolder';
import CheckoutHolder from './components/CheckoutHolder';
import FlashWidget from '../flash';
import SquaresWidget from '../squares';
import CompetitionWidget from '../competition';
import { useIsInViewport } from '../../src/Components/ViewportObserver';
import { AdProvider } from '../../src/AdServer';
import FreeBonusBanner from '../market2/components/FreeBonusBanner';
BEClarity.initializeClarity('smlyytjo0o')

type EmbedAppProps = {
    identifier?:string
}

type EmbedAdProps = {
    ready?:boolean,
    onAnimationEnd?:() => void,
    onNavOut:() => void,
    embed_size: { width:number, height:number, layout:'banner'|'card' },
    loading?: boolean,
    error?: boolean
}

const EmbedAd = ({ embed_size, ready, onAnimationEnd, onNavOut, loading, error }:EmbedAdProps) => {
    const Colors = useColors();
    if(embed_size.width == 0){ return <></> }

    // Render loading state for card layout
    if(loading && embed_size.layout == 'card'){
        return (
            <View style={{ flex:1, justifyContent:'center', alignItems:'center', padding:40 }}>
                <Icons.BettorEdgeIcon size={48} color={Colors.text.h1} />
                <Text theme='h1' style={{ marginTop:24, textAlign:'center' }}>Loading BettorEdge...</Text>
                <Text theme='description' style={{ marginTop:10, textAlign:'center' }}>
                    Connecting to the marketplace
                </Text>
            </View>
        )
    }

    // Render error state for card layout
    if(error && embed_size.layout == 'card'){
        return (
            <View style={{ flex:1, justifyContent:'center', alignItems:'center', padding:40 }}>
                <Icons.BettorEdgeIcon size={48} color={Colors.text.h1} />
                <Text theme='h1' style={{ marginTop:24, textAlign:'center' }}>BettorEdge</Text>
                <Text theme='description' style={{ marginTop:10, textAlign:'center', maxWidth:300 }}>
                    The community-powered sports betting exchange where you set the odds
                </Text>
                <View style={{ marginTop:24, width:'100%', maxWidth:400 }}>
                    <FreeBonusBanner
                        amount="$10"
                        message="FREE to place your first bet!"
                        ctaText="Claim Bonus"
                        onPress={() => onNavOut()}
                    />
                </View>
            </View>
        )
    }

    // Render loading state for banner layout
    if(loading && embed_size.layout == 'banner'){
        return (
            <View style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', padding:10 }}>
                <Icons.BettorEdgeIcon size={18} color={Colors.text.h1} />
                <View transparent style={{ marginLeft:10 }}>
                    <Text theme='h2'>Loading BettorEdge...</Text>
                    <Text theme='description' style={{ marginTop:3 }}>Connecting to the marketplace</Text>
                </View>
            </View>
        )
    }

    // Render error state for banner layout (clickable)
    if(error){
        return (
            <View style={{ flex:1, padding:5, justifyContent:'center' }}>
                <View transparent style={{ flexDirection:'row', alignItems:'center', gap:10 }}>
                    <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                        <Icons.BettorEdgeIcon size={16} color={Colors.text.h1} />
                        <View transparent style={{ marginLeft:8 }}>
                            <Text theme='h2' size={12}>BettorEdge</Text>
                            <Text theme='description' size={10} style={{ marginTop:2 }}>Community-powered betting exchange</Text>
                        </View>
                    </View>
                    <View transparent style={{ flex:1 }} />
                    <View style={{ flexShrink:0 }}>
                        <FreeBonusBanner
                            amount="$10"
                            message="FREE to place your first bet!"
                            ctaText="Claim Bonus"
                            onPress={() => onNavOut()}
                        />
                    </View>
                </View>
            </View>
        )
    }

    if(false && embed_size.layout == 'card'){
        if(!onAnimationEnd){
            return (
                <Button transparent style={{ padding:0, position:'absolute', top:0, left:0, right:0, bottom:0 }} onPress={() => onNavOut()}>
                    <Image
                        source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1755278752/24.09_Review_Future_1x1_Electric_bvo0rp.png' }}
                        style={{ width: embed_size.width, height: embed_size.height, borderRadius:8 }}
                        resizeMode='contain'
                    />
            </Button>
            )
        }
        return (
            <View type='blur' style={{ position:'absolute', top:0, left:0, right:0, bottom:0 }}>
                <CircularFadeOut start={ready ?? false} onComplete={() => onAnimationEnd()} animationTime={1}>
                    <Image
                        source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1755278752/24.09_Review_Future_1x1_Electric_bvo0rp.png' }}
                        style={{ width: embed_size.width - 10, height: embed_size.height - 10, borderRadius:8, margin:5 }}
                        resizeMode='contain'
                    />
                </CircularFadeOut>
            </View>
        )
    }
    if(!onAnimationEnd){
        return (
            <Button transparent style={{ flex:1, padding:0, position:'absolute', top:0, left:0, right:0, bottom:0 }} onPress={() => onNavOut()}>
                 <View style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                    <Icons.BettorEdgeIcon size={18} color={Colors.text.h1} />
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme='h2'>BettorEdge</Text>
                        <Text theme='description' style={{ marginTop:3 }}>Lines powered by the Bettoredge Community</Text>
                    </View>
                    <Button disabled backgroundColor={Colors.absolutes.brand.electric} style={{ flexDirection:'row', padding:10, alignItems:'center' }}>
                        <Icons.PhoneIcon size={14} color={Colors.text.white} />
                        <Text style={{ marginLeft:5 }} theme='h2' color={Colors.text.white}>Go to the app</Text>
                    </Button>
                </View>
            </Button>
        )
    }
    return (
        <View style={{ flex:1, padding:0, position:'absolute', top:0, left:0, right:0, bottom:0 }}>
            <CircularFadeOut start={ready ?? false} onComplete={() => onAnimationEnd()} animationTime={1}>
                <View style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                    <Icons.BettorEdgeIcon size={18} color={Colors.text.h1} />
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme='h2'>BettorEdge</Text>
                        <Text theme='description' style={{ marginTop:3 }}>Lines powered by the Bettoredge Community</Text>
                    </View>
                    <Button disabled backgroundColor={Colors.absolutes.brand.electric} style={{ flexDirection:'row', padding:10, alignItems:'center' }}>
                        <Icons.PhoneIcon size={14} color={Colors.text.white} />
                        <Text style={{ marginLeft:5 }} theme='h2' color={Colors.text.white}>Go to the app</Text>
                    </Button>
                </View>
            </CircularFadeOut>
        </View>
    )
}

const EmbedApp = ({identifier}:EmbedAppProps) => {
    Font.useFonts({
        BarlowBold: require('../assets/fonts/Barlow-Bold.ttf'),
        BarlowSemiBold: require('../assets/fonts/Barlow-SemiBold.ttf'),
        BarlowRegular: require('../assets/fonts/Barlow-Regular.ttf'),
        BarlowLight: require('../assets/fonts/Barlow-Light.ttf'),
    });

    const containerRef = useRef(null);
    const isInViewport = useIsInViewport(containerRef);
    const [ auth_state, setAuthState ] = useState<AuthStateProps | undefined>(undefined);
    const [ embed_size, setEmbedSize ] = useState<{ height:number, width:number, layout: 'banner'|'card' }>({
        height:0, width:0, layout: 'banner'
    });
    const [ embed_state, setEmbed ] = useState<{
        loading:boolean,
        loaded:boolean,
        embed?:EmbedProps,
        insets: { top:number, bottom:number, left:number, right:number },
        wallet: {
            visible:boolean
        },
        checkout:{
            visible:boolean,
            item_order?:ItemOrderProps,
            account_id?:string
        }
        ready:boolean,
        show_authenticate:boolean,
        show_embed:boolean,
        show_profile:{
            visible:boolean,
            show_welcome?:boolean,
            walkthrough?: { level: 'basic'|'verify' }
        },
        embed_properties:EmbedPropertyProps[],
        company?:CompanyProps,
        company_embed?:CompanyEmbedProps,
        error:boolean,
    }>({
        loading:false,
        loaded:false,
        error: false,
        insets: { top: 0, left:0, right:0, bottom:0 },
        wallet: { visible:false },
        checkout: { visible: false },
        ready:true,
        show_authenticate:false,
        show_embed:true,
        show_profile:{ visible: false },
        embed_properties:[]
    });
    const { wallet, checkout, loaded, show_authenticate, ready, insets, show_profile, show_embed, embed, company, embed_properties, company_embed } = embed_state;
    const referral_code = company_embed?.properties['refer'] ?? 'kickoff'
    const [ my_state, setMyState ] = useState<{
        me_loading:boolean,
        me?:MyPlayerProps,
        my_balance?:PlayerBalanceProps
    }>({
        me_loading: false,
    });
    const { me, my_balance } = my_state;

    const window_dimensions = useWindowDimensions();
    const mode = window_dimensions.width > 600 ? 'desktop' : 'mobile'

    useEffect(() => {
        BEClarity.setCustomTag('location','embed');
        BEClarity.setCustomTag('href', window.location.href);
    },[])

    useEffect(() => {
        if(!identifier || !isInViewport || loaded){ return }
        startEmbed(identifier);
    },[identifier, isInViewport]);

    useEffect(() => {
        if(!auth_state?.authenticated){ return }
        getMyData()
    },[auth_state?.authenticated]);

    const getMyData = async() => {
        ProfileApi.setEnvironment()
        setMyState({ ...my_state, me_loading: true });
        const { player } = await ProfileApi.getMyDetails();
        const pb = await ProfileApi.getMyBalance();
        setMyState({
            ...my_state,
            me_loading: false,
            me: player,
            my_balance: pb
        });
        BEClarity.identify(player.player_id, auth_state?.session_id);
    }
 
    const startEmbed = async(id:string) => {
        BEClarity.setCustomTag('embed_identifier', id);
        setEmbed({ ...embed_state, loading:true });
        //First! Lets see if we are locally authenticated
        const auth_resp = await APIOverrides.start({
            env: 'PRODUCTION_PROXY',
            no_cache:false
        });
        BEClarity.setCustomTag('be_session', auth_resp.session_id);
        BEClarity.setCustomTag('be_distinct', auth_resp.distinct_id);
        setAuthState(auth_resp);
        CompanyProfileApi.setEnvironment();
        const embed_details = await APIOverrides.getCompanyEmbedByIdentifier(id);
        if(!embed_details){
            setEmbed({ ...embed_state, error: true, loading: false });
            BEClarity.smartEvent('load_error');
            return //Stop!!
        }
        
        const top = parseInt(embed_details.company_embed.properties['paddingtop'] ?? '0')
        const bottom = parseInt(embed_details.company_embed.properties['paddingbottom'] ?? '0')
        const left = parseInt(embed_details.company_embed.properties['paddingleft'] ?? '0')
        const right = parseInt(embed_details.company_embed.properties['paddingright'] ?? '0')
        const insets = { top, bottom, left, right }
        const cpny = await CompanyProfileApi.getCompanyById(embed_details.company_embed.company_id)
        setEmbed({
            ...embed_state,
            loading: false,
            insets,
            loaded: true,
            embed: embed_details.embed,
            company: cpny?.company,
            company_embed: embed_details.company_embed,
            embed_properties: embed_details.embed_properties
        })
    }

    const handleNavOut = () => {
        if(!company_embed){ return Linking.openURL(`https://play.bettoredge.com?refer=${referral_code}&utm_medium=embed&utm_source=error`)}
        return Linking.openURL(`https://play.bettoredge.com?refer=${referral_code}&utm_medium=embed&utm_source=${company_embed?.identifier}`)
    }
    const renderEmbed = (my_embed:EmbedProps) => {
        switch(my_embed.name){
            case 'Market Embed':
                if(!company_embed){ return <EmbedAd embed_size={embed_size} onNavOut={handleNavOut}/>}
                const league_ids = company_embed.properties['league_ids']
                const default_league_id = company_embed.properties['leagueid'] as string | undefined
                const team_ids = company_embed.properties['team_ids']
                const athlete_ids = company_embed.properties['athlete_ids']
                //const width = company_embed.properties['width']
                const layout = company_embed.properties['layout'] as 'banner'|'card' | undefined
                const type = company_embed.properties['type'] ?? 'popular' as 'popular' | 'team' | 'league'
                const market_mode = window_dimensions.width > 800 ? 'desktop' : 'mobile'

                // Ad configuration - just enable/disable ads, AdServer handles the rest
                const show_ads_str = company_embed.properties['showads'] as '0'|'1'|undefined
                const show_ads = show_ads_str === '1' // Only show if explicitly enabled
                return (
                    <MarketEmbed
                        me={me}
                        insets={insets}
                        my_balance={my_balance}
                        type={type}
                        company={company}
                        default_league_id={default_league_id}
                        mode={market_mode}
                        clarity={BEClarity}
                        authenticating={show_authenticate}
                        show_profile={show_profile.visible}
                        onNavOut={() => handleNavOut()}
                        layout={layout ?? embed_size.layout}
                        league_ids={league_ids}
                        team_ids={team_ids}
                        athlete_ids={athlete_ids}
                        show_ads={show_ads}
                        device_width={embed_size.width}
                        onShowWallet={() => {
                            if(!me){ return }
                            if(me.vouched_status != 'verified'){
                                alert('We must verify your account before you can make real money deposits and withdraws');
                                 let walkthrough:undefined|{ level:'basic'|'verify' } = !me.first_name || me.no_password ? { level:'basic' }:  { level: 'verify' }
                                let show_welcome = !me.first_name ? true : false
                                BEClarity.smartEvent('show_profile')
                                return setEmbed({ ...embed_state, show_profile: { visible: true, walkthrough, show_welcome } });
                            }
                            BEClarity.smartEvent('show_wallet')
                            setEmbed({ ...embed_state, wallet: { visible:true } });
                        }}
                        onShowProfile={() => {
                            if(!me){ return }
                            BEClarity.smartEvent('show_profile')
                            let walkthrough:undefined|{ level:'basic'|'verify' } = !me.first_name || me.no_password ? { level:'basic' }: me.vouched_status != 'verified' ? { level: 'verify' } :undefined
                            let show_welcome = !me.first_name ? true : false
                            setEmbed({ ...embed_state, show_profile: { visible: true, walkthrough, show_welcome } });
                        }}
                        onLoaded={() => {
                            setEmbed({ ...embed_state, ready: true })
                        }}
                        onRequestAuthenticate={() => {
                            BEClarity.smartEvent('show_authenticate')
                            setEmbed({ ...embed_state, show_authenticate : true })
                        }}
                        onBuyOrder={(order) => {
                            // Order will be handled inside MarketEmbed
                            console.log('onBuyOrder called with order:', order);
                        }}
                    />
                )
            case 'Competition Embed':
                 if(!company_embed){ return <EmbedAd embed_size={embed_size} onNavOut={handleNavOut}/>}
                if(!company || !auth_state?.distinct_id){ return <></> }
                const comps_layout = company_embed.properties['layout'] as 'banner'|'card' | undefined
                return (
                    <CompetitionWidget
                        me={me}
                        my_balance={my_balance}
                        company={company}
                        layout={comps_layout ?? embed_size.layout}
                        mode={mode}
                        distinct_id={auth_state.distinct_id}
                        onShowWallet={() => {
                            if(!me){ return }
                            if(me.vouched_status != 'verified'){
                                alert('We must verify your account before you can make real money deposits and withdraws');
                                 let walkthrough:undefined|{ level:'basic'|'verify' } = !me.first_name || me.no_password ? { level:'basic' }:  { level: 'verify' }
                                let show_welcome = !me.first_name ? true : false
                                BEClarity.smartEvent('show_profile')
                                return setEmbed({ ...embed_state, show_profile: { visible: true, walkthrough, show_welcome } });
                            }
                            BEClarity.smartEvent('show_wallet')
                            setEmbed({ ...embed_state, wallet: { visible:true } });
                        }}
                        onShowProfile={() => {
                            if(!me){ return }
                            let walkthrough:undefined|{ level:'basic'|'verify' } = !me.first_name || me.no_password ? { level:'basic' }: me.vouched_status != 'verified' ? { level: 'verify' } :undefined
                            let show_welcome = !me.first_name ? true : false
                            BEClarity.smartEvent('show_profile')
                            setEmbed({ ...embed_state, show_profile: { visible: true, walkthrough, show_welcome } });
                        }}
                        insets={insets}
                        onRequestAuthenticate={() => {
                            BEClarity.smartEvent('show_authenticate')
                            setEmbed({ ...embed_state, show_authenticate : true })
                        }}
                    />
                )
            case 'Squares Embed':
                if(!company_embed){ return <EmbedAd embed_size={embed_size} onNavOut={handleNavOut}/>}
                if(!company || !auth_state?.distinct_id){ return <></> }
                const squares_layout = company_embed.properties['layout'] as 'banner'|'card' | undefined
                return (
                    <SquaresWidget
                        me={me}
                        my_balance={my_balance}
                        company={company}
                        layout={squares_layout ?? embed_size.layout}
                        mode={mode}
                        distinct_id={auth_state.distinct_id}
                        onShowWallet={() => {
                            if(!me){ return }
                            if(me.vouched_status != 'verified'){
                                alert('We must verify your account before you can make real money deposits and withdraws');
                                 let walkthrough:undefined|{ level:'basic'|'verify' } = !me.first_name || me.no_password ? { level:'basic' }:  { level: 'verify' }
                                let show_welcome = !me.first_name ? true : false
                                BEClarity.smartEvent('show_profile')
                                return setEmbed({ ...embed_state, show_profile: { visible: true, walkthrough, show_welcome } });
                            }
                            BEClarity.smartEvent('show_wallet')
                            setEmbed({ ...embed_state, wallet: { visible:true } });
                        }}
                        onShowProfile={() => {
                            if(!me){ return }
                            BEClarity.smartEvent('show_profile')
                            let walkthrough:undefined|{ level:'basic'|'verify' } = !me.first_name || me.no_password ? { level:'basic' }: me.vouched_status != 'verified' ? { level: 'verify' } :undefined
                            let show_welcome = !me.first_name ? true : false
                            setEmbed({ ...embed_state, show_profile: { visible: true, walkthrough, show_welcome } });
                        }}
                        insets={insets}
                        onRequestAuthenticate={() => {
                            BEClarity.smartEvent('show_authenticate')
                            setEmbed({ ...embed_state, show_authenticate : true })
                        }}
                    />
                )
            case 'Flash Market':
                if(!company_embed){ return <EmbedAd embed_size={embed_size} onNavOut={handleNavOut}/>}
                if(!company){ return <></> }
                const flash_layout = company_embed.properties['layout'] as 'banner'|'card' | undefined
                const flash_campaign_ids_str = company_embed.properties['flashcampaignids']
                const flash_market_ids_str = company_embed.properties['flashids']
                const inline_str = company_embed.properties['inline'] as '1'|'0'|undefined
                const inline = inline_str == '1' ? true : false
                let flash_campaign_ids:string[] = []
                let flash_ids:string[] = []
                if(flash_campaign_ids_str){ flash_campaign_ids = flash_campaign_ids_str.split(',') }
                if(flash_market_ids_str){ flash_ids = flash_market_ids_str.split(',') }
                return (
                    <FlashWidget
                        company={company}
                        me={me}
                        layout={flash_layout ?? embed_size.layout}
                        my_balance={my_balance}
                        mode={mode}
                        inline={inline}
                        flash_campaign_ids={flash_campaign_ids}
                        flash_ids={flash_ids}
                        insets={insets}
                        onShowProfile={() => {
                            if(!me){ return }
                            BEClarity.smartEvent('show_profile')
                            let walkthrough:undefined|{ level:'basic'|'verify' } = !me.first_name || me.no_password ? { level:'basic' }: me.vouched_status != 'verified' ? { level: 'verify' } :undefined
                            let show_welcome = !me.first_name ? true : false
                            setEmbed({ ...embed_state, show_profile: { visible: true, walkthrough, show_welcome } });
                        }}
                        onShowWallet={() => {
                            if(!me){ return }
                            if(me.vouched_status != 'verified'){
                                alert('We must verify your account before you can make real money deposits and withdraws');
                                 let walkthrough:undefined|{ level:'basic'|'verify' } = !me.first_name || me.no_password ? { level:'basic' }:  { level: 'verify' }
                                let show_welcome = !me.first_name ? true : false
                                BEClarity.smartEvent('show_profile')
                                return setEmbed({ ...embed_state, show_profile: { visible: true, walkthrough, show_welcome } });
                            }
                            BEClarity.smartEvent('show_wallet')
                            setEmbed({ ...embed_state, wallet: { visible:true } });
                        }}
                        onRequestAuthenticate={() => {
                            BEClarity.smartEvent('show_authenticate')
                            setEmbed({ ...embed_state, show_authenticate : true })
                        }}
                    />
                )
            default:
                return (
                    <EmbedAd embed_size={embed_size} onNavOut={handleNavOut}/>
                )
        }
    }
    if(!company_embed || !embed || !auth_state){
        // Determine state: if not loaded and no error, we're loading
        const isLoading = !embed_state.loaded && !embed_state.error;
        return (
            <View ref={containerRef}  style={{ width:'100%', height:'100%' }}  onLayout={(ev) => {
                const { height, width } = ev.nativeEvent.layout;
                let min_height = 75
                let layout:'card'|'banner' = width < 675 ? 'card' : 'banner'
                if(layout == 'card'){ min_height = 400 }
                let embed_height = height < min_height ? min_height : height
                setEmbedSize({ height:embed_height, width, layout })
            }}>
                <EmbedAd
                    embed_size={embed_size}
                    onNavOut={handleNavOut}
                    loading={isLoading}
                    error={embed_state.error}
                />
            </View>
        )
    }

    return (
        <AdProvider
            distinct_id={auth_state?.distinct_id}
            session_id={auth_state?.session_id}
            role={me?.role}
        >
            <View transparent style={{ height:'100%', width:'100%', maxWidth:window_dimensions.width }}>
            <View transparent style={{ flexGrow:1 }} onLayout={(ev) => {
                const { height, width } = ev.nativeEvent.layout;
                let min_height = 75
                let layout:'card'|'banner' = width < 675 ? 'card' : 'banner'
                if(layout == 'card'){ min_height = 400 }
                let embed_height = height < min_height ? min_height : height
                setEmbedSize({ height:embed_height, width, layout })
            }}>
                { renderEmbed(embed) }
                {!show_embed ?
                    <EmbedAd onNavOut={handleNavOut} ready={ready} embed_size={embed_size} onAnimationEnd={() => setEmbed({ ...embed_state, show_embed:true })}/>
                :<></>}
            </View>
            <AuthenticatorHolder
                visible={show_authenticate}
                mode={mode}
                insets={insets}
                company_id={company_embed.company_id}
                referral_code={referral_code}
                onClose={() => setEmbed({ ...embed_state, show_authenticate:false })}
                onAuthenticated={async(auth_response) => {
                    await APIOverrides.authenticateApp({ ...auth_response, authenticated:true, distinct_id: auth_state.distinct_id, session_id: auth_state.session_id}, { cache: true })
                    setAuthState({
                        ...auth_state,
                        authenticated:true,
                        ...auth_response
                    });
                    if(auth_response.new_player){ BEClarity.smartEvent('sign_up') }
                    BEClarity.smartEvent('login')
                    getMyData();
                    setEmbed({ ...embed_state, show_authenticate:false })
                }}
            />
            {me ?
            <ProfileHolder
                me={me}
                onClose={() => setEmbed({ ...embed_state, show_profile: { visible: false } })}
                mode={mode}
                insets={insets}
                walkthrough={show_profile.walkthrough}
                show_welcome={show_profile.show_welcome}
                visible={show_profile.visible}
                onLogout={async() => {
                    await APIOverrides.logoutApp();
                    setAuthState({
                        distinct_id: auth_state.distinct_id,
                        session_id: auth_state.session_id,
                        authenticated: false
                    });
                    setMyState({ me_loading: false }) //Remove all the user data
                }}
            />
            :<></>}
            {me?
            <WalletHolder
                me={me}
                visible={wallet.visible}
                mode={mode}
                insets={insets}
                my_balance={my_balance}
                onClose={() => setEmbed({ ...embed_state, wallet: { visible:false } })}
                onTransact={(io, account_id) => {
                    setEmbed({ 
                        ...embed_state,
                        wallet: { visible:false },
                        checkout:{
                            visible: true,
                            item_order:io,
                            account_id: account_id
                        }
                    });
                }}
            />
            :<></>}
            {me && checkout.item_order?
            <CheckoutHolder
                mode={mode}
                insets={insets}
                visible={checkout.visible}
                order={checkout.item_order}
                onManageAccount={() => {
                    setEmbed({ ...embed_state, checkout: { ...checkout, visible: false }, wallet: { visible: true } })
                }}
                onCompleteOrder={(io, tranny) => {
                    setEmbed({ ...embed_state, checkout: { visible: false } })
                    alert('Successully processed order!')
                    getMyData()
                }}
                onClose={() => setEmbed({ ...embed_state, checkout: { visible: false } })}
            />
            :<></>}
        </View>
        </AdProvider>
    )
}

export default EmbedApp